import { Component } from '../core/Component';
import { Vector2 } from '../core/Vector2';

/**
 * Rendering types for different entity shapes
 */
export enum RenderingType {
  Rectangle = 'rectangle',
  Circle = 'circle',
  Pacman = 'pacman',
  TopDownPerson = 'top_down_person', // Top-down view of a person with animated legs
  Ghost = 'ghost',
  PowerPellet = 'power_pellet',
  CustomShape = 'custom_shape',
  IcyWall = 'icy_wall', // Added for snow/ice maze
  RigidMudBrickWall = 'rigid_mud_brick_wall', // Added for rigid mud brick wall
  SaharaWall = 'sahara_wall', // Added for desert/sahara maze
  AmazonWall = 'amazon_wall', // Added for jungle/amazon maze
  AtlanticWall = 'atlantic_wall', // Added for ocean/atlantic maze
  SpaceWall = 'space_wall', // Added for space/cosmic maze
  MuddyWall = 'muddy_wall', // Added for muddy/mud brick maze
  DesertDecoration = 'desert_decoration', // Added for desert decorations
}

/**
 * Sprite component for visual representation
 * Pure data component - no behavior/logic
 */
export class SpriteComponent extends Component {
  public color: string;
  public size: Vector2;
  public texture?: string;
  public textureRegion?: {
    x: number;
    y: number;
    width: number;
    height: number;
  };
  public points: Vector2[];
  public visible: boolean;
  public opacity: number;
  public zIndex: number;
  public rotation: number; // For visual rotation/direction
  public renderingType: RenderingType;
  public renderingData?: any; // Generic data for custom rendering (e.g., direction for Pacman)

  constructor(
    color: string = '#0000FF',
    size: Vector2 = new Vector2(32, 32),
    texture?: string,
    visible: boolean = true,
    opacity: number = 1.0,
    zIndex: number = 0,
    renderingType: RenderingType = RenderingType.Rectangle
  ) {
    super();
    this.color = color;
    this.size = size;
    this.texture = texture;
    this.points = [];
    this.visible = visible;
    this.opacity = opacity;
    this.zIndex = zIndex;
    this.rotation = 0;
    this.renderingType = renderingType;
  }

  public clone(): SpriteComponent {
    const clone = new SpriteComponent(
      this.color,
      this.size.clone(),
      this.texture,
      this.visible,
      this.opacity,
      this.zIndex,
      this.renderingType
    );

    clone.textureRegion = this.textureRegion
      ? { ...this.textureRegion }
      : undefined;
    clone.points = this.points.map((point) => point.clone());
    clone.rotation = this.rotation;
    clone.renderingData = this.renderingData
      ? { ...this.renderingData }
      : undefined;

    return clone;
  }
}
